import { useAppBack } from '../../hooks/useAppBack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NmButton } from '../../components/NmButton';
import { NmCard } from '../../components/NmCard';
import { SettingsPageHeader } from './SettingsPageHeader';
import { IoNotificationsOutline } from 'react-icons/io5';
import { NmToggle } from '../../components/NmToggle';
import { useWebPush } from '../../hooks/useWebPush';
import { usePwaInstall } from '../../context/PwaInstallContext';

/** Notification preferences — in-app inbox + optional Web Push (FCM). */
export function MobileNotificationSettingsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goBack = useAppBack('/settings');
  const push = useWebPush();
  const install = usePwaInstall();

  const hintKey =
    push.availability === 'ios_needs_install'
      ? 'notifications.pushIosNeedsInstall'
      : push.availability === 'not_configured'
        ? 'notifications.pushNotConfigured'
        : push.availability === 'unsupported'
          ? 'notifications.pushUnsupported'
          : null;

  return (
    <div className="mobile-screen mobile-settings-screen">
      <SettingsPageHeader
        title={t('notifications.settingsTitle', 'Notification settings')}

        icon={IoNotificationsOutline}
        onBack={goBack}
      />

      <NmCard variant="raised-sm" className="notif-settings-row">
        <div className="notif-settings-row__text">
          <strong>{t('notifications.alertToggle', 'Alert notifications')}</strong>
          <p>{t('notifications.alertToggleDesc', 'Receive notification alerts on this device.')}</p>
          {hintKey ? <p className="notif-settings-row__hint">{t(hintKey)}</p> : null}
          {push.errorKey ? <p className="notif-settings-row__error">{t(push.errorKey)}</p> : null}
        </div>
        <NmToggle
          checked={push.enabled}
          disabled={push.busy || push.availability === 'unsupported'}
          onChange={(next) => void push.toggle(next)}
        />
      </NmCard>

      {push.availability === 'ios_needs_install' ? (
        <NmButton variant="secondary" style={{ marginTop: 12 }} onClick={install.showManual}>
          {t('pwa.install.showGuide')}
        </NmButton>
      ) : null}

      <NmButton variant="ghost" style={{ marginTop: 16 }} onClick={() => navigate('/notifications')}>
        {t('notifications.openInbox', 'Open inbox')}
      </NmButton>
    </div>
  );
}
